import { CreatePayroll } from '../../pages';
import { PayrollController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { object, string, number } from 'yup';

const CreatePayrollContainer = ({ closeModal }) => {
	const [loading, setLoading] = useState(false);
	const [stage2, setStage2] = useState(false);

	const goBack = () => {
		if (stage2) {
			setStage2(false);
		} else {
			closeModal();
		}
	};

	const onSubmit = async payload => {
		setLoading(true);
		for (const key in payload) {
			if (payload[key] === '') {
				delete payload[key];
			}
		}
		const { status, errorMessage } = await PayrollController.createPayroll(
			payload
		);
		setLoading(false);
		if (status === constant.Success) {
			setStage2(true);
			MimaToastUtil.success({
				message: constant.Success,
			});
			return closeModal();
		}
		MimaToastUtil.error({
			message: errorMessage,
		});
	};

	const schemaValidation = () => {
		return object({
			month: number().required('Month is required'),
			year: string().required('Year is required'),
			settlementCycle: string().required('Week is required'),
			week: string().test(function () {
				const { settlementCycle, week } = this.parent;
				return !week && settlementCycle === 'WEEKLY'
					? this.createError({
							message: 'Week is required',
							path: 'week',
					  })
					: true;
			}),
			biWeek: string().test(function () {
				const { settlementCycle, biWeek } = this.parent;
				return !biWeek && settlementCycle === 'BI-WEEKLY'
					? this.createError({
							message: 'Bi-Week is required',
							path: 'biWeek',
					  })
					: true;
			}),
		});
	};

	return (
		<CreatePayroll
			closeModal={closeModal}
			onSubmit={onSubmit}
			schemaValidation={schemaValidation}
			loading={loading}
			goBack={goBack}
		/>
	);
};

export default observer(CreatePayrollContainer);
